import { FC } from 'react';

export const DecimalPoint: FC = () => {
  return <span style={{ fontWeight: 'bold', fontSize: '40px', marginLeft: '0px' }}>.</span>;
};
